import { render, staticRenderFns } from "./MenuMargins.vue?vue&type=template&id=37b92eda&scoped=true&"
import script from "./MenuMargins.vue?vue&type=script&lang=js&"
export * from "./MenuMargins.vue?vue&type=script&lang=js&"
import style0 from "./MenuMargins.vue?vue&type=style&index=0&id=37b92eda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b92eda",
  null
  
)

export default component.exports